import Irmao, { InputIrmao, ParametrosDeBuscaIrmao } from './../../common/types/Irmao'
import axios from '@/plugins/axios'
import { AxiosRequestConfig } from 'axios'
import { IUser } from 'common/types/User'
import { Novidade } from 'common/types/Novidade'

export default class IrmaoService {

	static async find(params: ParametrosDeBuscaIrmao = {}, config?: AxiosRequestConfig) {
		try {
			const { data } = await axios.get<Irmao[]>('/irmaos', {
				params: {
					...params,
					...config?.params,
				},
				...config,
			})
			return data
		} catch (error) {
			throw error
		}
	}

	static async me() {
		try {
			const result = await axios.get<IUser>(`/irmaos/me`)
			return result.data
		} catch (error) {
			throw error
		}
	}

	static async novidades() {
		try {
			const result = await axios.get<Novidade>(`/irmaos/me/novidades`)
			return result.data
		} catch (error) {
			throw error
		}
	}

	static async get(id: string, config?: AxiosRequestConfig) {
		try {
			const result = await axios.get<Irmao>(`/irmaos/${id}`, config)
			return result.data
		} catch (error) {
			throw error
		}
	}

	static async put(id: string, input: InputIrmao) {
		try {
			const result = await axios.put<Irmao>(`/irmaos/${id}`, input)
			return result.data
		} catch (error) {
			throw error
		}
	}

	static async post(input: InputIrmao) {
		try {
			const result = await axios.post<Irmao>(`/irmaos`, input)
			return result.data
		} catch (error) {
			throw error
		}
	}

	static async patch(id: string, input: Partial<InputIrmao>) {
		try {
			const result = await axios.patch<Irmao>(`/irmaos/${id}`, input)
			return result.data
		} catch (error) {
			throw error
		}
	}

	static async remove(id: string) {
		try {
			const result = await axios.delete<Irmao>(`/irmaos/${id}`)
			return result.data
		} catch (error) {
			throw error
		}
	}
}
